import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalPpsisUpdates } from '../actions';
import {
  getGlobalPpsis,
  getGlobalUpdatePpsis,
  getIsFetching
} from '../selectors';

const useUpdatesGlobalPpsis = () => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  // const globalUpdatePpsis = useSelector(getGlobalUpdatePpsis);
  const globalUpdatePpsis = useSelector(getGlobalPpsis);

  useEffect(() => {
    dispatch(fetchGlobalPpsisUpdates());
  }, [dispatch]);

  return [isFetching, globalUpdatePpsis];
};

export default useUpdatesGlobalPpsis;
